module.exports = __webpack_public_path__ + "img/reward-ratio-ilustra.5844cb21.png";